import { render, staticRenderFns } from "./OrganisationSelector.vue?vue&type=template&id=39d8222a&"
import script from "./OrganisationSelector.vue?vue&type=script&lang=js&"
export * from "./OrganisationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports